var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"bg-shape bg-shape-1"}),_c('div',{staticClass:"bg-shape bg-shape-2"}),_c('div',{staticClass:"bg-shape bg-shape-3"}),_c('FormLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }